import { render } from "./apg-dropdown.vue?vue&type=template&id=8adf47a8&scoped=true"
import script from "./apg-dropdown.vue?vue&type=script&lang=js"
export * from "./apg-dropdown.vue?vue&type=script&lang=js"

import "./apg-dropdown.vue?vue&type=style&index=0&id=8adf47a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8adf47a8"]])

export default __exports__